import fp from 'lodash/fp'
import { createAction } from 'redux-actions'

export const types = {
  START: 'metronome/START',
  STOP: 'metronome/STOP',

  TICK_MIN_5: 'metronome/TICK_MIN_5'
}

export const actions = {
  start: createAction(types.START),
  stop: createAction(types.STOP),
  tickMin5: createAction(types.TICK_MIN_5)
}

export const timers = {
  TICK_MIN_5: {
    type: types.TICK_MIN_5,
    action: actions.tickMin5,
    delay: 5 * 60 * 1000
  }
}

const getInitialState = () => ({})

export default function reducer (state = getInitialState(), { type, payload }) {
  if (fp.startsWith('metronome/TICK_', type)) {
    return fp.set(`${type}`, Date.now(), state)
  }
  return state
}
